import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const get_curated_media_list = createAsyncThunk<any, any, any>(
  'auto/get/curated/media/lists/for/management',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/curated/media/lists/for/management'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const storeCuratedMediaListAsync = createAsyncThunk<any, any, any>(
  'auto/store/curated/media/list/for/management',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/store/curated/media/list/for/management'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const deleteCuratedMediaListAsync = createAsyncThunk<any, any, any>(
  'auto/delete/curated/media/list/for/management',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/delete/curated/media/list/for/management'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const load_media = createAsyncThunk<any, any, any>(
  'auto/load/media/for/management',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/load/media/for/management'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_release_schedule_actions_for_curated_media_lists =
  createAsyncThunk<any, any, any>(
    'auto/get/release/schedule/action/for/curated/media/lists',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/get/release/schedule/action/for/curated/media/lists',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const get_release_schedule_actions_for_curated_media_list =
  createAsyncThunk<any, any, any>(
    'auto/get/release/schedule/action/for/curated/media/list',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/get/release/schedule/action/for/curated/media/list',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const update_release_schedule_actions_for_curated_media_list =
  createAsyncThunk<any, any, any>(
    'auto/update/release/schedule/action/for/curated/media/list',
    async (params, apiThunk: { getState: any }) => {
      let { getState } = apiThunk
      let state = getState()
      let bearToken = getBearerToken(state)
      if (bearToken) {
        try {
          let response = await fetch(
            ResolveUrl(
              'auto/update/release/schedule/action/for/curated/media/list',
            ),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${bearToken}`,
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify(params),
            },
          )
          let res = await response.json()
          if (params && params.callback) {
            params.callback(true, res)
          }

          return res
        } catch (e) {
          if (params && params.callback) {
            params.callback(false, e)
          }
        }
      } else {
        if (params && params.callback) {
          params.callback(false)
        }
        throw 'not signed in'
      }
    },
  )

export const get_content_houses_for_curated_list = createAsyncThunk<
  any,
  any,
  any
>(
  'auto/get/content/houses/for/curated/list',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/content/houses/for/curated/list'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_media_for_curated_media_list = createAsyncThunk<any, any, any>(
  'auto/get/media/action/for/curated/media/list',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(
          ResolveUrl('auto/get/media/action/for/curated/media/list'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${bearToken}`,
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(params),
          },
        )
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
